import type { ReactNode } from 'react';
interface Opt {
  value: string;
  label: ReactNode;
}
export function FilterSelect({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: Opt[];
}) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-sm-label font-semibold text-ink-2">{label}</span>
      <select
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 px-2 rounded-btn border border-line bg-surface text-body"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
